export default "__VITE_ASSET__DELgKtTF__"